// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_k3-0";
export var discountCodeInput = "_k3-1";